
import { mergeStyleSets, ProgressIndicator } from "@fluentui/react";
import { observer, inject } from "mobx-react";
import { Component } from "react";
import PwProps from "../props/PwProps";

const classNames = mergeStyleSets({
  toast: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '100%',
    height: '100vh'
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.4)'
  },
  content: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    boxShadow: '0 0 6px 0 rgba(0,0,0,0.16)'
  },
  progressError: {
    selectors: {
      '& .ms-ProgressIndicator-progressBar': {
        backgroundColor: '#a80000'
      },
      '& .ms-ProgressIndicator-itemName': {
        color: '#a80000',
        fontWeight: 600
      },
      '& .ms-ProgressIndicator-itemDescription': {
        color: '#a80000'
      }
    }
  },
  progressSuccess: {
    selectors: {
      '& .ms-ProgressIndicator-progressBar': {
        backgroundColor: '#107c10'
      },
      '& .ms-ProgressIndicator-itemName': {
        color: '#107c10',
        fontWeight: 600
      },
      '& .ms-ProgressIndicator-itemDescription': {
        color: '#107c10'
      }
    }
  }
})

@inject('importStore')
@observer
export default class PwToast extends Component<PwProps> {
  render() {
    const { importStore } = this.props;
    
    let progressClass = '';
    let label = 'Importando información desde Peopleware';
    let percentComplete = undefined;

    if (importStore?.importState === 'error') {
      progressClass = classNames.progressError;
      percentComplete = 1;
    } else if (importStore?.importState === 'success') {
      progressClass = classNames.progressSuccess;
      percentComplete = 1;
    }

    return (
      <div className={classNames.toast}>
        <div className={classNames.overlay}></div>
        <div className={classNames.content}>
          <ProgressIndicator
            className={progressClass}
            label={label}
            description={ importStore?.importState === 'error' ? importStore?.errorMessage : importStore?.stepLabel}
            percentComplete={percentComplete}
          />
        </div>
      </div>
    );
  }
}